export class ExcluirEstoqueNotaFiscalEntradaDialogData {
  numeroNota = '';
}
